"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeNamespace = _interopRequireDefault(require("hublabs-experiments/helpers/makeNamespace"));

var _CrmPrecacheExperiment = _interopRequireDefault(require("hublabs-experiments/experiments/CrmPrecacheExperiment"));

var _default = (0, _makeNamespace.default)({
  name: 'CrmPrecacheNamespace',
  segments: 100,
  allowAutoExposureLogging: false,
  setupExperiments: function setupExperiments(addExperiment, removeExperiment) {
    // 10% of population
    addExperiment('CrmPrecacheExperiment', _CrmPrecacheExperiment.default, 10); // 25% of population

    addExperiment('CrmPrecacheExperiment', _CrmPrecacheExperiment.default, 15);
  }
});

exports.default = _default;
module.exports = exports.default;